import { TOP_LEVEL_NAV_OPTIONS } from '@/constants/nav';

export function buildPendoForAgentsNavItem ({ t, hasAgentToolkitRedirect }) {
    return [{
        name: TOP_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        title: t('sideNav.agentToolkit.Agent Toolkit'),
        iconComponent: 'AgentToolkitNavIcon',
        suffixIcon: false,
        route: { name: 'AgentToolkit' },
        pendoAnalytics: 'agent-toolkit-nav-item',
        hasRedirect: () => hasAgentToolkitRedirect(),
        tag: {
            type: 'beta',
            size: 'small',
        },
    }];
}
